module.exports = __webpack_public_path__ + "static/media/water-waste.efb0ddf9.png";